<script lang="ts">
  import { AppPageHeader } from '../../framework/components/app';
  import CreditUsageList from './CreditUsageList.svelte';
</script>

<div class="page-shell admin-list">
  <AppPageHeader
    title="Credit usage"
    subtitle="Each completed AI output consumes one credit. Token counts and estimated model cost are shown per row."
    showAction={false}
  />
  <CreditUsageList />
</div>

